import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'routed-layout',
  imports: [
    RouterOutlet
  ],
  templateUrl: './routed-layout-shared.component.html',
  styleUrl: './routed-layout-shared.component.scss',
})
export class RoutedLayoutSharedComponent {}
